export class UrlWithRedirectParam {
  public execute(url: string, locationSearch: string): string {
    const queryParams = new URLSearchParams(locationSearch)
    const redirectTo = queryParams.get('redirectTo')

    return redirectTo ? url + '?redirectTo=' + redirectTo : url
  }
}
